<template>
    <div>
        <div class="project-container clearfix">
            <div class="project-list">
				<el-row :gutter="20">
                    <el-col class="project-item" :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                        <div class="grid-content add-project" @click="() => {$router.push('/projectsystem-creating')}">
                            <div class="add-project-name">+{{$t('project.addProjectSystem')}}</div>
                        </div>
                    </el-col>
                    <el-col class="project-item  " :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-for="v in systemList" :key="v.oid">
                        <el-card shadow="hover" :body-style="{ padding: '0px' }" class="project-card">
                           <div class="project-card-body">
                               <div class="project-card-meta">
                                  <!-- <div class="project-card-meta-avatar" @click="handleGoProject(v)">
                                       <span v-if="v.icon === ''" class="iconfont icon-yingyong-moren"></span>
                                       <img v-else :src="v.icon" alt="">
                                   </div> -->
                                   <div class="project-card-meta-detail">
										<span class="project-status normal">正常</span>
										<span class="project-card-title" @click="handleGoProject(v)">{{v.project_system_name}}</span>
										<span class="project-card-des" :title="v.oid">子系统ID：{{v.oid}}</span>
										<span class="project-card-des" :title="v.description">备注：{{v.description}}</span>
                                      <!-- <span class="project-card-des" :title="v.province+'/'+v.city+'/'+v.dist">所属地区：{{v.province+'/'+v.city+'/'+v.dist}}</span> -->
                                   </div>
                               </div>
                           </div>
                           <div class="project-card-actions">
                               <ul>
                                   <li @click.stop.prevent="editDetail(v)">
                                       <span><i class="el-icon-edit"></i>编辑</span>
                                   </li>
                                   <li @click.stop.prevent="deleteDetail(v)">
                                       <span><i class="el-icon-delete"></i>删除</span>
                                   </li>
                               </ul>
                           </div>
                        </el-card>
                    </el-col>														
                </el-row>
                <!-- <el-pagination v-if="project.count > pageSize" :page-size="7" background layout="prev, pager, next" :total="project.count" @current-change="currentChange">
                </el-pagination> -->
            </div>
			<div class="back-home"><router-link to="/projectlist"><i class="el-icon-back icon-btn"></i></router-link></div>
        </div>
        <el-dialog :title="$t('btns.edit')" :visible.sync="dialogVisible" width="50%" class="project-form-edit">
            <system-form :editData="editData"></system-form>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SystemForm from "../CmpProjectForm/CmpSystemForm";
import Storage from '@/utils/storage'
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
import { getAreaName } from '@/utils/transRegionsData';

export default {
    name: "",
    provide() {
        return {
            handleEdit: this.handleEdit
        }
    },
    data() {
        return {
            // 查询条件
			systemList:[],
            // form: {
            //     project_id: '',//项目子系统名称
            // },
            Regions: [],    //  地区ID
            dialogVisible: false,   //弹窗状态
            editData: {},   //  存储单个项目子系统信息
            pageSize: 7,
            page: 1,
        };
    },
    components: {
        // 项目子系统表单组件
        SystemForm
    },
	created() {
		this.getList()
		// this.form.project_id = await Service.getProjectId()
	},
  //   mounted() {
  //       let params = Object.assign({}, this.form)
  //       // 获取项目子系统列表
  //       this.$store.dispatch("GetProjectSystemList", params)
		
  //   },
	
    computed: {
        // 项目子系统列表
        ...mapGetters(['projectsystemList', "user","projectInfo","projectsystemInfo"])
    },
    methods: {
		//获取子系统列表
        async getList() {
            this.loading = true;
            let data = await Service.getProjectSystemList();
			if(data == "success"){
				this.systemList = []
			}else{
				this.systemList = data
			}
			
            // if(data){
            //     data = data === 'success' ? [] : data;
            //     this.systemList = data;
            // }
        },
        // 查询项目子系统
        handleSearch() {
            if(this.Regions) {
                let { proviceName, cityName, areaName } = getAreaName(this.Regions, this.baseData.regionsData);  //  格式化省市区
                this.form.province= proviceName || ""
                this.form.city = cityName || ""
                this.form.dist = areaName || ""
            }
            let params = Object.assign({}, this.form, this.pagination)
            this.$store.dispatch("GetProjectList", params);
        },
        // 隐藏编辑弹框
        async handleEdit() {
            this.dialogVisible = false;
            
            let params = await Service.getProjectSystemList();
            this.systemList = params
			// let params = Object.assign({}, this.form, this.pagination)
			//this.$store.dispatch("GetProjectList", params)
			// 刷新列表数据
			
        },
        // 显示编辑弹框
        editDetail(v) {
            if(this.user.usertype >= 4) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
            this.dialogVisible = true;
            this.editData = v;
        },
        // 删除项目子系统
        deleteDetail(v) {
            if(this.user.usertype >= 4) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
            $Alert(`是否确认删除 ${v.project_system_name} `).then( async (bool)=>{
                if(bool){
                    let data = await Service.deleteProjectSystem({ oid: v.oid });
                    if(data) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                        });
						this.getList()
                        // 刷新列表数据
						// let params = await Service.getProjectSystemList();
						// this.systemList = params
                        // let params = Object.assign({}, this.form, this.pagination)
                        // this.$store.dispatch("GetProjectList", params)
                    }
                }
            });
        },
        // 进入项目子系统
        handleGoProject(v) {
            // 设置项目子系统ID
            Storage.set('SYSTEM_OID',{system_oid:v.oid});
            Storage.set('ProjectSystemInfo',{projectsystemInfo:v});     //  本地缓存系统信息，减少OID获取系统信息次数)
            if(v.sys_type_id === 1) {
                if(v.oid == 33) {
                    this.$router.push({ path: "/machinemana/0" });
                }else{
                    // 机房系统
                    this.$router.push({ path: "/machineHome" });
                }
            }else if(v.sys_type_id === 3){
                // 新机房子系统
                this.$router.push({ path: "/machinemana/0" });
            }else{
                // 群控系统+计费系统
                this.$router.push({ path: "/home" });
            }
        },
        currentChange(curPage) {
            const data = {
                uid: this.uid,
                pageSize: this.pageSize,
                page: curPage
            };
            this.$store.dispatch("GetProjectSystemList", data);
        },
    },
};
</script>

<style scoped>
.back-home{
    position: absolute;
    left: 10px;
    top: 10px;
    font-size: 20px;
}
.project-list .el-pagination {
    margin-top: 24px;
    float: right;
}
.el-dialog__header {
    text-align: left;
}
.project-container{
	position: relative;
}
</style>

<style lang="less" scoped>	
.project-item {
    margin-bottom: 20px;
    &:last-child{
        margin-bottom: 0;
    }
}
.project-card{
    background-color: #fff;
    .project-card-body{
        padding: 10px;
        overflow: hidden;
        .project-card-meta{
            overflow: hidden;
            .project-card-meta-avatar{
                margin-right: 16px;
                float: left;
                width: 48px;
                height: 48px;
                line-height: 48px;
                border-radius: 48px;
                overflow: hidden;
                img{
                    width: 100%;
                }
                span{
                    vertical-align: middle;
                    font-size: 24px;
                    color:rgba(0, 0, 0, 0.45);
                }
            }
            .project-card-meta-detail{
                margin-left: 64px;
                font-size: 0;
                color: rgba(0,0,0,.45);
                text-align: left;
                height: 100px;
                position: relative;
                span{
                    display: block;
                }
                .project-status{
                    position: absolute;
                    right: 0;
                    z-index: 9;
                    top: 0;
                    font-size: 14px;
                    line-height: 24px;
                    &::before{
                            content: "";
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            margin-right: 5px;
                            border-radius: 50%;
                            vertical-align: middle;
                        }
                    &.normal{
                        color: @primary-color;
                        &::before{
                            background-color: @primary-color;
                        }
                    }
                    &.warn{
                        color: @warning-color;
                        &::before{
                            background-color: @warning-color;
                        }
                    }
                    &.error{
                        color: @error-color;
                        &::before{
                            background-color: @error-color;
                        }
                    }
                }
                .project-card-title{
                    font-size: 16px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    height: 42px;
                    color: rgba(0,0,0,.85);
                    font-weight: 500;
                    margin-bottom: 5px;
                    margin-right: 45px;
                    cursor: pointer;
                    &:hover{
                        color: @primary-color;
                    }
                    
                }
                .project-card-des{
                    font-size: 14px;
                    position: relative;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 100%;
                    line-height: 28px;
                }
            }
        }
    }
    .project-card-actions{
        ul{
            border-top: 1px solid #e8e8e8;
            background: #f7f9fa;
            zoom: 1;
            list-style: none;
            margin: 0;
            padding: 0;
            overflow: hidden;
            li{
                width: 50%;
                float: left;
                text-align: center;
                margin: 12px 0;
                color: rgba(0,0,0,.45);
                box-sizing: border-box;
                cursor: pointer;
                &:first-child{
                    border-right: 1px solid #e8e8e8;
                }
                &:hover{
                    color: @primary-color;
                }
                i{
                    margin-right: 8px;
                }
            }
        }
    }
}

// 搜索
.project-search{
    margin:50px 0;
    text-align:left;
}
.project-list {
    max-width: 1200px;
    margin: 35px auto;
}
.project-name img {
    width: auto;
    height: 16px;
    vertical-align: middle;
}
.project-list .project-name {
    width: 100%;
    text-align: center;
}
.grid-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 166px;
    background: #fff;
    cursor: pointer;
}
.grid-content:hover {
    box-shadow: 1px 1px 2px 1px #ddd;
    color: @primary-color;
}
.add-project {
    width: 100%;
    color: rgba(0, 0, 0, 0.45);
    background-color: rgb(255, 255, 255);
}
.add-project:hover {
    border: 1px dashed @primary-color;
    box-sizing: border-box;
}
.operate-box {
    position: absolute;
    right: 10px;
    top: 8px;
}
</style>
